// extracted by mini-css-extract-plugin
export default {"notificationPortalViewContainer":"NotificationPortalView_notificationPortalViewContainer__Zasfs"};